import { render, staticRenderFns } from "./customTab.vue?vue&type=template&id=8d2ff670&scoped=true"
import script from "./customTab.vue?vue&type=script&lang=js"
export * from "./customTab.vue?vue&type=script&lang=js"
import style0 from "./customTab.vue?vue&type=style&index=0&id=8d2ff670&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d2ff670",
  null
  
)

export default component.exports